import {ApiClient} from "../../shared/api/apiClient.ts";


export class UserApi extends ApiClient {
    private readonly ENDPOINT = '/user';
    constructor() {
        super()
    }

    public async getUserBalance() {
        const response = await this.get<{balance: number }>(`${this.ENDPOINT}/balance`);
        return response;
    }
}

